export default {
  getContactAvatar: state => contactId => {
    return state.avatars.contacts[contactId];
  },

  getAgentAvatar: state => agentId => {
    return state.avatars.agents[agentId];
  }
};
